<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<section style="{style(block)}">
  <div class="container">
    <div class="row mt-5">
      {#each blocklist(block, 'offers') as item}
      <div class="col-lg-3 col-sm-6 mb-lg-4 mb-4">
        <div class="card shadow-none border h-100">
          <div class="card-header text-sm-start text-center pt-4 pb-3 px-4">
            <div style="min-height: 150px;">
              <h5 class="mb-1">{text(item, 'title')}</h5>
              <p class="mb-3 text-sm">{text(item, 'subtitle')}</p>
              <h3 class="font-weight-bolder mt-3">
                {text(item, 'price')}
              </h3>
            </div>
            <a href="{url(item, 'buyButton')}" class="btn btn-sm bg-gradient-dark w-100 border-radius-md mt-4 mb-2">
              {text(item, 'buyButton')}
            </a>
          </div>
          <hr class="horizontal dark my-0">
          <div class="card-body">
            <div class="d-flex pb-3">
              {@html richtext(item, 'features')}
            </div>
          </div>
        </div>
      </div>
      {/each}
    </div>
  </div>
</section>
